export const ArrayToCommaSeparatedList = fields => {
  if (!Array.isArray(fields)) {
    throw new Error(
      `field "fields" is not a valid Array, it's ${typeof fields}`
    );
  }
  return fields.join(",");
};
